import {Component, Input, EventEmitter, Output, OnInit} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable , throwError } from 'rxjs';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { PageNotificationService, AuthService } from '@signature-it/ngx-generic/services';
import { B2BUserDTO } from '@signature-it/ngx-generic/models';
import {  IUser } from '@signature-it/ngx-generic/interfaces';
import { CartSummaryDTO, CartTotalPriceDTO } from '@signature-it/ngx-catalogue/models';
import { CartActions } from '@signature-it/ngx-catalogue/store/actions';
import * as fromSelectors from '@signature-it/ngx-catalogue/store/selectors';

declare let _: any;

@Component({
    selector: 'cart-summary',
    templateUrl: './summary.html',
    styleUrls: ['./summary.scss'],
    standalone: false
})
export class CartSummaryComponentGeneric implements OnInit {
    @Input() data: CartSummaryDTO;
    @Input() showCoupon = false;
    @Input() isMiniCart = false;
    @Input() removeDelivery = false;
    totalPrice$: Observable<CartTotalPriceDTO>;
    loadingTotalPrice$: Observable<boolean>;
    loadingTotalQuantity$: Observable<boolean>;
    usersData: IUser;
    labelSuffix: string;
    useOneCoupon = GenericConfig.useOneCoupon;

    constructor(protected notifySvc: PageNotificationService,
                protected store$: Store<any>,
                protected authService: AuthService) {

        this.totalPrice$ = this.store$.select(fromSelectors.getCartTotalPrice);
        this.loadingTotalPrice$ = this.store$.select(fromSelectors.getLoadingTotalPrice);
        this.loadingTotalQuantity$ = this.store$.select(fromSelectors.getLoadingTotalQuantity);
    }

    ngOnInit(): void {
        this.getUserData();
        this.getTotalPrice(this.removeDelivery);
        this.totalPrice$.subscribe((data: CartTotalPriceDTO) => {
            if (data) {
                setTimeout(() => {
                    this.data.TotalPriceBeforeDiscount = data.total_price_before_discount;
                    this.data.TotalPriceAfterDiscount = data.total_price_after_discount;
                    this.data.DeliveryPrice = data.delivery_price;
                    this.data.Vat = data.calculated_vat;
                    this.data.SessionCurrency = data.session_currency;
                    this.data.Points = data.points_discount;
                    this.data.DeliveryDiscount = data.delivery_discount;
                    this.data.calcTotalPrice();
                    this.data.calcDiscountTotalPrice();
                    this.data.AdditionalData = data.additional_data;
                }, 0);
            }
        }, (error: Response) => {
            this.notifySvc.set(error).show();
        });

    }

    getUserData() {
        this.authService.usersData$.subscribe((user: IUser) => {
            this.labelSuffix = user instanceof B2BUserDTO ? 'b2b' : 'b2c';
        });
    }

    calcTotalItemsPrice() {
        this.data.TotalItemsPrice = this.data.TotalPriceBeforeDiscount > 0 && this.data.DeliveryPrice > 0
            ? this.data.TotalPriceBeforeDiscount - this.data.DeliveryPrice
            : this.data.TotalPriceBeforeDiscount;
    }

    get hasDiscountPrice(): boolean {
        return this.data.hasDiscountPrice();
    }
    updateTotalPrice(){
       this.getTotalPrice(this.removeDelivery);
    }

    getTotalPrice(removeDelivery) {
        const action = CartActions.getTotalPrice(removeDelivery);
        this.store$.dispatch(action);
    }
}
